import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import { useAuthentication } from 'wmic-digital-auth-react';
import { useHistory } from 'react-router-dom';
import { getConfigValue } from '@jutro/config';

import metadata from './WMICLogoutPage.metadata.json5';

function WMICLogoutPage() {
    const { isAuthenticated } = useAuthentication();
    const history = useHistory();

    useEffect(() => {
        if (isAuthenticated) {
            try {
                const keysToRemove = [];
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key && (key.startsWith('okta-') || key.includes('okta'))) {
                        keysToRemove.push(key);
                    }
                }
                keysToRemove.forEach(key => localStorage.removeItem(key));
            } catch (e) {
                // best effort
            }
        }
        history.push('/logout-confirmation');
    }, [])

    const overrideProps = {
        logoutContainer: {
        }
    };

    const resolvers = {
        resolveComponentMap: {}
    };

    WMICLogoutPage.propTypes = {
        match: PropTypes.shape({}).isRequired
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

export default withRouter(WMICLogoutPage);
